import type { RequestsClosedReason } from "@touchscreen/api-client";
import { useCountdown } from "./useCountdown.js";

/**
 * Copy for every documented `requests.reason`, shared so both surfaces say the same thing.
 * Legacy silently hid the buttons — that reads as a broken screen. See
 * touchscreen-frontend.md §Closed and unavailable states. `outside_geofence` is phone-only in
 * practice (a kiosk is bolted to a wall) but is included for completeness.
 */
export function useClosedStateMessage(
  reason: RequestsClosedReason | null,
  nextTransitionAt: string | null,
): string | null {
  const countdown = useCountdown(reason === "closed_by_schedule" ? nextTransitionAt : null);

  if (!reason) return null;

  switch (reason) {
    case "closed_by_schedule":
      return countdown ? `Requests open in ${countdown}` : "Requests are currently closed";
    case "player_offline":
      return "The music system here isn't responding right now";
    case "product_disabled":
      return "Requests aren't available here right now";
    case "outside_geofence":
      return "You need to be in the venue to request";
    default:
      return "Requests aren't available right now";
  }
}
